export default __webpack_public_path__ + "static/media/automation-marketing.7a9eea93.svg";